import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'
import { Navbar } from 'flowbite-react'
import { useState } from 'react'

export default function Nav () {

    const [ closeMenu, setCloseMenu ] = useState(false)

    const toggleMenu = () => {
        setCloseMenu(!closeMenu)
    }

    return (
        <Navbar
            className="navbar"
            fluid={true}
            rounded={false} 
        >
            <Navbar.Brand>
                <span className="self-center whitespace-nowrap ml-3 text-green-400 text-xl font-semibold dark:text-white" id="mono-text">
                JDC
                </span>
            </Navbar.Brand>

            <Navbar.Toggle className="hover:bg-green-500 hover:text-green-500" />
        
            <Navbar.Collapse>
            <Navbar.Link 
                href="/" 
                id="nav-link"
                >
                Home
            </Navbar.Link>

            <Navbar.Link 
                href="/portfolio" 
                id="nav-link"
                >
                Portfolio
            </Navbar.Link>

            <Navbar.Link 
                href="/about-me" 
                id="nav-link"
                >
                About
            </Navbar.Link>

            <Navbar.Link 
                href="#contact" 
                id="nav-link"
                >
                Contact
            </Navbar.Link>
              
                {/* <Link to="/" onClick={toggleMenu} className="block py-2 pl-3 pr-4 text-white rounded hover:text-green-400 md:bg-transparent md:p-0 dark:text-white"> Home </Link>
            
                <Link to="/portfolio" className="block py-2 pl-3 pr-4 text-white rounded hover:bg-gray-800 hover:text-purple-400 md:hover:bg-transparent md:border-0 md:hover:text-purple-400 md:p-0 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent"> Portfolio </Link>
        
                <Link to="/about-me" className="block py-2 pl-3 pr-4 text-white rounded hover:bg-gray-800 hover:text-yellow-300 md:hover:bg-transparent md:border-0 md:hover:text-yellow-300 md:p-0 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent"> About </Link>

                <HashLink smooth to="#contact" className="block py-2 pl-3 pr-4 text-white rounded hover:bg-gray-800 hover:text-pink-400 md:hover:bg-transparent md:border-0 md:hover:text-pink-400 md:p-0 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">Contact</HashLink> */}
        

            </Navbar.Collapse>
        </Navbar>
    )
}